module.exports = __webpack_public_path__ + "static/img/石头扫拖一体 P20 Pro.65e9d41c.png";